import { render, staticRenderFns } from "./HvApvCell.vue?vue&type=template&id=b8d6056e"
import script from "./HvApvCell.vue?vue&type=script&lang=js"
export * from "./HvApvCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports